import { Link } from '@99designs/emu';
import { linkTo } from '@99designs/routing';
import { IconFreelancer, IconMoneyBack, IconStar, IconSupport } from './icons';
import type { ZendeskLanguage } from '@99designs/routing';
import type { Reason } from './ReasonCard';

export const getReasons = (language: ZendeskLanguage = 'en'): ReadonlyArray<Readonly<Reason>> => [
    {
        heading: __('4.8/5 star rating'),
        description: (
            <>
                {__('That’s our average rating from')}
                &nbsp;
                <Link target="_blank" href={'/testimonials'}>
                    {__('37,533 customer reviews.')}
                </Link>
                &nbsp;
                {__('Happy designers make happy clients.')}
            </>
        ),
        icon: <IconStar />,
    },
    {
        heading: __('100% money-back guarantee for contests'),
        description: (
            <>
                {__('Great design, guaranteed. Love your final design or get your money back.')}
                &nbsp;
                <Link
                    target="__blank"
                    href={`${linkTo.supportUrl('204108729', 'articles', language)}`}
                >
                    {__('T&Cs apply')}
                </Link>
            </>
        ),
        icon: <IconMoneyBack />,
    },
    {
        heading: __('Verified freelance logo designers'),
        description: __(
            'Our logo designers are vetted, creative professionals with verified industry experience who take the time to understand your business.'
        ),
        icon: <IconFreelancer />,
    },
    {
        heading: __('24/7 design support'),
        description: __(
            'Get help when you need it with our support team of real bonafide humans. No question is too small or complex!'
        ),
        icon: <IconSupport />,
    },
];
